import { SessionId, HandleId } from '../message';
import { TransportBase } from './Transport';
import { logEvent } from 'infrastructure/sora/logging';
import { ignore } from 'utility/ignore';

async function openSocket(
    server: string,
    protocol: string,
    onmessage: (e: MessageEvent) => void
) {
    const ws = new WebSocket(server, protocol);

    const willOpen = new Promise<WebSocket>(resolve => {
        ws.onopen = ev => {
            logEvent('ws is opened')(ev);
            resolve(ws);
        };
    });
    ws.onclose = logEvent('ws is closed');
    ws.onerror = logEvent('ws sent an error');

    ws.addEventListener('message', onmessage);

    return await willOpen;
}

export type WebsocketTransportConfig = {};

export class WebsocketTransport extends TransportBase {
    private readonly _ws: Promise<WebSocket>;

    get ws() {
        return this._ws;
    }

    constructor(server: string, config: WebsocketTransportConfig) {
        super();

        ignore(config);

        this._ws = openSocket(server, 'janus-protocol', e => {
            this._onmessage(JSON.parse(e.data));
        });
    }

    protected _startSubscribing(sessionId: number) {
        // nothing to do due to the nature of websocket
        ignore(sessionId);
    }

    protected async _sendMessage(
        tx: string,
        command: string,
        sessionId: SessionId | undefined,
        handleId: HandleId | undefined,
        body: object | undefined
    ) {
        const ws = await this.ws;

        ws.send(
            JSON.stringify({
                janus: command,
                transaction: tx,
                'session_id': sessionId,
                'handle_id': handleId,
                ...body,
            })
        );
    }

    async keepalive(sessionId: SessionId) {
        this.sendRequest('keepalive', sessionId);
    }
}
